import { createReducer } from "@reduxjs/toolkit";
import { AddressStateType } from "@ob/layouts/VendorOnboarding/types/address";
import va from "@ob/layouts/VendorOnboarding/redux/actions";

export const initAddressState = {
  street1: "",
  street2: "",
  city: "",
  state: "",
  zip: "",
};

const addressReducer = createReducer<AddressStateType>(
  initAddressState,
  (builder) => {
    builder
      .addCase(va.kyb.admin.address.setAddressValue, onSetAddressValue)
      .addCase(va.kyb.admin.address.clearAddress, onClearAddress);
  },
);
export default addressReducer;

export function onSetAddressValue(
  state: AddressStateType,
  action: ReturnType<typeof va.kyb.admin.address.setAddressValue>,
) {
  if (action.payload.key in state) {
    state[action.payload.key as keyof AddressStateType] = action.payload.value;
  }
}

export function onClearAddress(state: AddressStateType) {
  state.street1 = "";
  state.street2 = "";
  state.city = "";
  state.state = "";
  state.zip = "";
}
